import type { WSModel } from "@/services/socket/ws.service";
import { WSCommands } from "@/constants/ws";
import { socketEmitter } from "@/services/socket/socket-emitter";

export class TruckHandler implements WSModel {
  handleWSData(data: any) {
    if (!data.command) {
      return;
    }

    switch (data.command) {
      case WSCommands.truckReserved:
        this.handleTruckReserved(data);
        break;
    }
  }

  recoveryHandler(lastEvent: Date | null): void {
    socketEmitter.emit("truck:reconnected", { lastEvent });
  }

  private handleTruckReserved(data: any) {
    socketEmitter.emit("truck:reserved", data);
  }
}
